import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import ButtonBase from '@material-ui/core/ButtonBase'

import TimeAgo from 'react-timeago'
import jaStrings from 'react-timeago/lib/language-strings/ja'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import { makePath } from '../../../lib';
import { Word } from '../../../containers';
import { WID, getWord } from '../../../constants/Language';
import { Link } from 'react-router-dom'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
const formatter = buildFormatter(jaStrings)

const styles = theme => ({
  flexBox: {
    display: 'flex',
  },
  flexEndBox: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  commentBox: {
    display: 'flex',
    marginBottom: theme.spacing.unit * 2,
  },
  avatar: {
    marginRight: theme.spacing.unit * 2,
  },
  displayName: {
    fontWeight: 'bold',
    marginRight: theme.spacing.unit,
  },
  timeAgo: {
    width: 100,
    color: theme.palette.grey[500]
  }
})

class Comment extends React.Component {
  state = {
    comment: '',
  }

  handleTextChange = (event) => {
    this.setState({ comment: event.target.value })
  }

  handleClickComment = () => {
    this.setState({ comment: '' })
    this.props.handleClickComment(this.state.comment)
  }

  componentDidMount() {
    if (this.props.id !== undefined) {
      this.props.init()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id && nextProps.id !== undefined) {
      this.props.init()
    }
  }

  componentWillUnmount() {
  }

  render() {
    const { classes, id, settings, record, handleClickDelete, language } = this.props
    const { comment } = this.state
    if (id !== undefined) {
      return (
        <div key={id}>
          {settings && (
            <React.Fragment>
              <div className={classes.flexBox}>
                <CustomAvatar
                  alt={settings.displayName}
                  name={settings.displayName}
                  src={settings.avatarPhotoURL}
                  className={classes.avatar}
                />
                <TextField
                  fullWidth
                  value={comment}
                  placeholder={getWord(WID.COMMENT.ENTER_A_COMMENT, language)}
                  onChange={this.handleTextChange}
                />
              </div>
              <div className={classes.flexEndBox}>
                <Button onClick={this.handleClickComment}>
                  <Word wid={WID.COMMENT.COMMENT_BUTTON}/>
                </Button>
              </div>
            </React.Fragment>
          )}
          {record ? record.comments.map((comment, index) => {
            return (
              <div className={classes.commentBox} key={index}>
                <CustomAvatar
                  alt={comment.author.displayName}
                  name={comment.author.displayName}
                  src={comment.author.avatarPhotoURL}
                  className={classes.avatar}
                  component={Link}
                  to={makePath(`/user/${comment.author.userName}`, language)}
                />
                <div>
                  <div className={classes.flexBox}>
                    <ButtonBase component={Link} to={makePath(`/user/${comment.author.userName}`, language)}>
                      <Typography noWrap className={classes.displayName}>
                        {comment.author.displayName}
                      </Typography>
                    </ButtonBase>
                    <Typography className={classes.timeAgo}>
                      <TimeAgo date={comment.createDateTime} formatter={formatter}/>
                    </Typography>
                  </div>
                  <Typography>
                    {comment.comment}
                  </Typography>
                  {settings && settings.userName === comment.author.userName && (
                    <ButtonBase onClick={handleClickDelete(comment.index)}>
                      <Typography color='primary'><Word wid={WID.COMMENT.DELETE_BUTTON}/></Typography>
                    </ButtonBase>
                  )}
                </div>
              </div>
            )
          })
          : (
            <CircularProgress/>
          )}
        </div>
      )
    }
    else {
      return (
        <div>
          <Typography><Word wid={WID.COMMENT.MESSAGE_NOT_ALLOWED}/></Typography>
        </div>
      )
    }
  }
}

export default withStyles(styles, { withTheme: true })(Comment)


// WEBPACK FOOTER //
// ./src/components/Common/Comment/Comment.js